import { Card } from "@design";
import type { ReactNode } from "react";
import { Text } from "@/components/Text";

/** A titled card holding one page section (Recent activity, Pinned, Agents…). */
export function SectionCard({
  title,
  action,
  className = "",
  children,
}: Readonly<{ title: string; action?: ReactNode; className?: string; children: ReactNode }>) {
  return (
    <Card className={`flex flex-col gap-2 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <Text as="h2" variant="eyebrow" tone="tertiary">
          {title}
        </Text>
        {action}
      </div>
      {children}
    </Card>
  );
}
